import { assertContentType } from '@/helpers/assertContentType';
import { parseFilename } from '@/helpers/parseFilename';
import { createHHAxios } from '@/references/axios/axios';
import { HHAPIService } from '@/references/axios/base';
import type { RequestOptions } from '@/references/axios/types';
import type { ClientType } from '@/references/base';

import type { StatementDownloadResult, Transaction } from './types';

export class HHAPITransactionsService extends HHAPIService {
  private readonly baseURL: string;
  private readonly clientType: ClientType;

  constructor(baseURL: string, clientType: ClientType) {
    super('transactions.api.service');
    this.baseURL = baseURL;
    this.clientType = clientType;
  }

  async getTransactions(opts?: RequestOptions): Promise<Transaction[]> {
    const instance = createHHAxios({
      baseURL: this.baseURL,
      headers: this.getClientTypeHeaders(this.clientType)
    });

    const resp = await instance.request<{ transactions: Transaction[] }>({
      method: 'GET',
      url: '/v1/private/transactions',
      withCredentials: true,
      opts
    });

    return resp.data.payload.transactions;
  }

  async getOTCStatement(id: string): Promise<StatementDownloadResult> {
    const instance = createHHAxios({
      baseURL: this.baseURL,
      headers: this.getClientTypeHeaders(this.clientType),
      responseType: 'blob'
    });

    const resp = await instance.requestRaw<Blob>({
      url: `/v1/private/receipts/otc/${id}`,
      method: 'GET',
      headers: {
        Accept: 'application/pdf'
      },
      withCredentials: true
    });

    assertContentType(resp.headers, 'application/pdf');
    return {
      filename: parseFilename(resp.headers) ?? `Transaction_Statement_${id}.pdf`,
      blob: new Blob([resp.data], { type: 'application/pdf' })
    };
  }
}
